import { Box, Flex, Heading, Button, Image, Text } from '@everlywell/ui-kit';
import { ArrowDown } from '@phosphor-icons/react';
import React from 'react';

interface IHero {
  eyebrow?: string;
  eyebrowColor?: string;
  headline: string;
  description?: {
    childMarkdownRemark: {
      rawMarkdownBody: string;
    };
  };
  backgroundColor: string;
  desktopImage: {
    url: string;
    title: string;
  };
  cta: {
    text: string;
    url: string;
  };
}

export const Hero = ({
  eyebrow,
  eyebrowColor,
  headline,
  description,
  backgroundColor,
  desktopImage,
  cta,
}: IHero) => {
  const scrollToNextSection = () => {
    const heroBox = document.querySelector('[data-testid="hero-box"]');
    const nextSection = heroBox?.nextElementSibling;
    if (nextSection) {
      nextSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  return (
    <Box
      data-testid="hero-box"
      as="section"
      backgroundColor={backgroundColor}
      height={['auto', 'auto', '620px']}
      display="flex"
      alignItems="center"
      position="relative"
      padding="1rem"
      overflow="hidden"
    >
      <Box maxWidth="1440px" w="100%" mx="auto" data-testid="hero-section">
        <Flex
          direction={['column', 'column', 'row']}
          alignItems="center"
          justifyContent="space-between"
          width="100%"
        >
          <Box
            flex="1"
            paddingRight={[0, 0, 8]}
            marginTop={['4.5rem', '1rem', '4rem']}
            textAlign={['center', 'left', 'left']}
          >
            <Text
              fontSize="sm"
              fontWeight="medium"
              color={eyebrowColor ? eyebrowColor : '#28724f'}
              mb={4}
            >
              {eyebrow}
            </Text>
            <Heading as="h1" size="2xl" marginBottom={4}>
              <Box as="span" color="blue.base">
                {headline}
              </Box>
            </Heading>
            <Text color="#545454">
              {description?.childMarkdownRemark?.rawMarkdownBody}
            </Text>
            <Button
              onClick={scrollToNextSection}
              rightIcon={<ArrowDown />}
              size="md"
              variant="solid"
              backgroundColor="#012B3B"
              color="white"
              marginTop={['4', '4', '8']}
            >
              {cta?.text}
            </Button>
          </Box>
          <Box flex="1" marginTop={['2rem', '0', '0']}>
            <Image
              position={['relative', 'relative', 'absolute']}
              transform={['translateX(8%)', 'none', 'none']}
              top={['0', '0', '0']}
              right={['0', '0', '-6.5rem', '0']}
              height={['auto', 'auto', '100%']}
              width="auto"
              src={desktopImage?.url}
              alt={desktopImage?.title}
            />
          </Box>
        </Flex>
      </Box>
    </Box>
  );
};
